export const asset = {
  name_one: "asset",
  name_other: "assets",
  add: {
    label: "Add asset",
  },
  geojson: {
    label: "Linear assets",
  },
  technical: {
    label: "Technical",
    lastUpdate: "Last update {{date}}",
    lastUpdateBy: "by {{user}}",
  },
  components: {
    label: "Components",
  },
  interventions: {
    label: "Interventions",
  },
  observations: {
    label: "Observations",
  },
  timeline: {
    label: "Timeline",
    goToIntervention: "View intervention",
    modifiedBy: "Modified by",
    filterByType: "Filter by event type",
    filterBySubType: "Filter by event subtype",
    extraItems: {
      manufactured: {
        title: "Manufactured",
      },
      commissioned: {
        title: "Commissioned",
      },
      "theoretical-end-of-life": {
        title: "Theoretical end of life",
      },
      today: {
        title: "Today",
      },
    },
  },
  delete: {
    label: "Delete asset",
  },
  form: {
    associateAssetWith: {
      asset: "Associate this asset with",
      component: "Associate this component with",
    },
    informations: {
      asset: "Asset information",
      component: "Component information",
    },
    edit: {
      label: "Edit asset",
      label_other: "Edit {{count}} assets",
      component: "Edit component",
      component_other: "Edit {{count}} components",
    },
    add: {
      asset: "Add asset",
      component: "Add component",
    },
    name: {
      label: "Name",
    },
    assetType: {
      label: "Asset type",
      alert:
        'The information displayed in the "Technical" tab will be deleted by changing the type.',
    },
    referenceNumber: {
      label: "Reference number",
      isOptionalMessage:
        "If left empty, this field will be automatically populated",
    },
    description: {
      label: "Description",
    },
    manufacturer: {
      label: "Manufacturer",
    },
    model: {
      label: "Model",
    },
    serialNumber: {
      label: "Serial number",
    },
    manufactureDate: {
      label: "Date of manufacture",
    },
    serviceDate: {
      label: "Date of commissioning",
    },
    assetInfo: {
      label: "Asset info",
    },
    technicalInfo: {
      label: "Technical info",
    },
    state: {
      label: "State",
    },
    assetPicture: {
      label: "Asset photo",
    },
    location: {
      label: "Location",
    },
    organization: {
      label: "Organization",
    },
    parent: {
      label: "Parent",
    },
    assetFiles: {
      label: "Attached files",
    },
    severityGrid: {
      label: "Severity grid",
    },
    conditionRating: {
      label: "Condition rating",
    },
    cmmsId: {
      label: "CMMS ID",
    },
    erpId: {
      label: "ERP ID",
    },
    attendanceToken: {
      label: "Inspection attendance token",
      tokenProvided: "Token provided",
    },
    age: {
      label: "Asset age",
    },
    replacementCost: {
      label: "Replacement cost",
    },
    theoreticalLifespan: {
      label: "Theoretical lifespan",
      unit: "years",
      tooltip: "Estimated asset lifespan expressed in years",
    },
    theoreticalRemainingLifespan: {
      label: "Theoretical end of life",
    },
    studyFrequency: {
      label: "Study frequency",
      value: "{{nbrOfMonths}} months",
      unit: "months",
      tooltip: "Study cycle expressed in months",
    },
    lastStudy: {
      label: "Last study",
      tooltip:
        "Date determined based on the creation date of the last study for this asset.",
    },
    nextStudy: {
      label: "Next study",
      tooltip:
        "Date determined according to the last study as well as the study frequency.",
    },
    isStudyOverdue: {
      label: "The last study date for this asset is too old.",
    },
    planFile: {
      label: "Plan (PDF file)",
    },
    plan: {
      label: "Plan",
    },
    validation: {
      serviceDateBeforeManufactureDate:
        "Please enter a service date after the manufacture date.",
    },
  },
  batchEditSelect: {
    asset: {
      selected_one: "selected asset.",
      selected_other: "selected assets.",
    },
    component: {
      selected_one: "selected component.",
      selected_other: "selected components.",
    },
  },
  batchEdit: {
    formError: {
      default: "An error occurred while updating assets.",
      noItemUpdated: "No assets have been modified.",
    },
    state: {
      optionTitle: "Assets state",
    },
    assetType: {
      optionTitle: "Assets type",
      label: "Type",
      disabledTooltip:
        "Batch editing is only applicable to assets of the same type.",
      alert:
        'The information displayed in the asset "Technical" tab will be deleted when changing their type.',
      concernedAssets: "Assets concerned:",
      all: "All",
    },
    conditionRating: {
      optionTitle: "Assets condition rating",
      label: "Condition rating",
    },
    replacementCost: {
      optionTitle: "Assets replacement cost",
      placeholder: "Enter a cost",
    },
    location: {
      optionTitle: "Location / Sector",
      disabledTooltip:
        "Batch editing is only applicable for assets of the same organization.",
    },
  },
  batchTransition: {
    description_one: "Please apply a new status to the selected asset.",
    description_other:
      "Please apply a new status to the different selected assets.",
    info: "Replaced and terminated assets cannot be modified.",
    formSuccess:
      "All assets '{{initialState}}' have been changed to '{{newState}}' state.",
    formErrorGeneric:
      "An error occurred while editing assets '{{initialState}}'.",
    formErrorItems: "The following assets could not be modified: {{items}}.",
  },
  risk: {
    label: "Risk level",
    low: "Low",
    moderate: "Moderate",
    high: "High",
    critical: "Critical",
    none: "Not rated",
  },
  statistics: {
    conditionRating: {
      title: "Condition rating",
    },
    riskLevel: {
      title: "Risk level",
    },
    state: {
      title: "Status",
    },
    type: {
      title: "Distribution by asset type",
    },
  },
};
